import "./Finder.scss";

import React, { useEffect, useState } from "react";

import { Viewport } from "@itwin/core-frontend";
import { Dialog, DialogAlignment, Icon, IconInput } from "@itwin/core-react";
import { Button, Input } from "@itwin/itwinui-react";
//!!OA  import { IconButton } from "@itwin/itwinui-react";
import { CustomToolbarItem, useToolbarPopupContext } from "@itwin/components-react";
import { ModalDialogManager, ModelessDialogManager } from "@itwin/appui-react";

import { cView } from "./View";
import { cMessage } from "./Message";
import { cSelection } from "./Selection";

let defaultString: string = "";

export function FinderPanel() {
  const [searchTag, setSearchTag] = useState(defaultString);

  useEffect(() => {
    setSearchTag(defaultString);
  }, []);

  const { closePanel } = useToolbarPopupContext();

  const handleApply = React.useCallback(() => {
    closePanel();
  }, [closePanel]);

  const onChangeSearch = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTag(event.target.value);
    defaultString = event.target.value;
  }

  const onKeyDnSearch = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      await cSelection.selectElementByTag(searchTag, false);
      const selCount = cSelection.getSelectionCount();
//      if (selCount === 1) {
      if (selCount > 0) {
          await cView.zoomToSelection();
      } else if (selCount > 1) {
        cMessage.showStatusBarError(`Multiple objects found, please enter complete tag Id for zoom`);
      } else {
        cMessage.showStatusBarError(`${searchTag} doesn't exist in the model`);
      }
    }
  }

  return (
    <div
      style={{
        width: "200px",
        height: "38px",
        padding: "6px",
        boxSizing: "border-box",
      }}
    >
      <IconInput
        type="search"
        id="search"
        placeholder="Enter Tag/Id"
        icon={<Icon iconSpec="icon-zoom" />}
        defaultValue={searchTag ?? {}}
        onChange={onChangeSearch}
        onKeyDown={onKeyDnSearch}
      />
    </div>
  );
}

export class cFinder {
  private static _tag: string = "";
  private static _width = 250;
  private static _height = 43;

  private static onChangeSearch = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    cFinder._tag = event.target.value;
    console.log("cFinder:onChangeSearch: " + event.target.value);
  };

  // const getOffset = (element: HTMLElement) => {
  //   const rect = element.getBoundingClientRect();
  //   return {
  //     left: rect.left + window.scrollX,
  //     top: rect.top + window.scrollY,
  //     bottom: rect.bottom,
  //     right: rect.right,
  //   };
  // };

  // const _openDialog = () => {
  //   const offset = getOffset(viewport!.canvas);
  // }

  public static popupFindButton(priority: number): CustomToolbarItem {
    const button: CustomToolbarItem = {
      isCustom: true,
      id: "findTag",
      itemPriority: priority,
      icon: "icon-zoom",
      isActive: true,
      label: "Find & Go To Tag/Id",
      panelContentNode: <FinderPanel />,
    };

    return button;
  }

  //!!OA finder tool - place find dialog on viewport - NOT USED!!!
  private static finderLocation(vp: Viewport) {
    cFinder.stopFinderTool("finder");
    cFinder.startFinderTool();
    console.log("Size changed-x: ", vp.viewRect.width);
  }

  public static startFinderTool = () => {
    const vp = cView.getCurrentView()
    const x = vp.viewRect.width - 1000; // should be left of toolbar
    const y = 60;

    vp.onResized.addListener(cFinder.finderLocation);
    ModelessDialogManager.openDialog(cFinder.finderDialog(x, y), "finder");
    console.log("finder");
  };

  public static stopFinderTool(id: string) {
    const vp = cView.getCurrentView()
    vp.onResized.removeListener(cFinder.finderLocation);
    ModelessDialogManager.closeDialog(id);
  }

  private static finderDialog(x: number, y: number): React.ReactNode {
    return (
      <Dialog
        opened={true}
        modal={false}
        hideHeader={true}
        x={x}
        y={y}
        width={cFinder._width}
        height={cFinder._height}
        minWidth={cFinder._width}
        minHeight={cFinder._height}
      >
        <div className="options">
          <input
            type="search"
            id="finder"
            onChange={cFinder.onChangeSearch}
          ></input>
          {/*<IconButton styleType='high-visibility' size='small' onClick={()=>{}}><span className="icon icon-issue-report" title={"icon-issue-report"} style={{ color: "white" }}></span></IconButton> */}
        </div>
      </Dialog>
    );
  }
  //!!OA
}
